import React from 'react';
import { Link } from 'react-router-dom';
import { useBreakpoint } from '../hooks/useBreakpoint';

const C = { primary: '#8B1A1A', gold: '#D4A017', bg: '#2C2C2C' };

export default function Footer() {
  const { isMobile } = useBreakpoint();

  const linkStyle = { display: 'block', color: '#aaa', textDecoration: 'none', fontSize: 14, marginBottom: 8, lineHeight: 1.6 };

  return (
    <footer style={{ background: C.bg, color: '#ccc', padding: isMobile ? '36px 20px 20px' : '48px 40px 24px', marginTop: 'auto' }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: isMobile ? 28 : 32,
        maxWidth: 1200,
        margin: '0 auto 28px',
      }}>
        {/* Brand — full width on mobile */}
        <div style={{ gridColumn: isMobile ? '1 / -1' : 'auto' }}>
          <h3 style={{ fontFamily: "'Playfair Display', serif", color: C.gold, fontSize: 20, marginBottom: 12 }}>A1 Looks</h3>
          <p style={{ fontSize: 13, lineHeight: 1.7, color: '#aaa', maxWidth: 300 }}>
            Fashion is more than just style — it's a statement. We celebrate cultural craftsmanship blended with contemporary trends.
          </p>
          <div style={{ marginTop: 14, display: 'flex', gap: 12 }}>
            <a href="https://facebook.com" style={{ fontSize: 20, textDecoration: 'none' }} target="_blank" rel="noreferrer">📘</a>
            <a href="https://instagram.com" style={{ fontSize: 20, textDecoration: 'none' }} target="_blank" rel="noreferrer">📸</a>
            <a href="https://x.com" style={{ fontSize: 20, textDecoration: 'none' }} target="_blank" rel="noreferrer">🐦</a>
            <a href="https://tiktok.com" style={{ fontSize: 20, textDecoration: 'none' }} target="_blank" rel="noreferrer">🎵</a>
          </div>
        </div>

        <div>
          <h4 style={{ fontFamily: "'Playfair Display', serif", color: '#fff', fontSize: 16, marginBottom: 14 }}>Quick Links</h4>
          <Link to="/shop?category=juttis" style={linkStyle}>Punjabi Juttis</Link>
          <Link to="/shop?category=earrings" style={linkStyle}>Earrings</Link>
          <Link to="/shop?category=necklaces" style={linkStyle}>Necklaces</Link>
          <Link to="/shop?category=bracelets" style={linkStyle}>Bracelets</Link>
          <Link to="/shop?category=rings" style={linkStyle}>Rings</Link>
          <Link to="/shop?category=potli-bags" style={linkStyle}>Potli Bags</Link>
          <Link to="/shop?is_best_seller=true" style={linkStyle}>Best Sellers</Link>
          <Link to="/shop?is_new_arrival=true" style={linkStyle}>New Arrivals</Link>
          <Link to="/shop?max_price=499" style={linkStyle}>Under ₹499</Link>
          <Link to="/shop?max_price=999" style={linkStyle}>Under ₹999</Link>
          <Link to="/about" style={linkStyle}>About Us</Link>
        </div>

        <div>
          <h4 style={{ fontFamily: "'Playfair Display', serif", color: '#fff', fontSize: 16, marginBottom: 14 }}>Policies</h4>
          <Link to="/privacy-policy" style={linkStyle}>Privacy Policy</Link>
          <Link to="/shipping-policy" style={linkStyle}>Shipping Policy</Link>
          <Link to="/terms" style={linkStyle}>Terms &amp; Conditions</Link>
          <Link to="/refund-policy" style={linkStyle}>Refund Policy</Link>
          <Link to="/contact" style={linkStyle}>Contact Us</Link>
        </div>

        <div>
          <h4 style={{ fontFamily: "'Playfair Display', serif", color: '#fff', fontSize: 16, marginBottom: 14 }}>Contact</h4>
          <p style={{ fontSize: 13, lineHeight: 1.9, color: '#aaa' }}>
            Neo Town Road<br />
            Bangalore 560100<br />
            +91 7042544844<br />
            rohini@A1looks.com
          </p>
        </div>
      </div>

      <div style={{ borderTop: '1px solid #444', paddingTop: 18, textAlign: 'center', fontSize: 13, color: '#888', maxWidth: 1200, margin: '0 auto' }}>
        <p>© {new Date().getFullYear()} A1 Looks. All rights reserved.</p>
      </div>
    </footer>
  );
}
